<template>
  <div class="card-bind">
      <van-nav-bar title="积分兑换" @click-left="onClickLeft"  left-arrow></van-nav-bar>
      <div class="top-info">
        <div class="top-1">
          <div class="now-integral">当前可用积分：{{stockInfo.balance}}</div>
          <div class="shop-btn" @click="goShop">去商城</div>
        </div>
        <div class="top-2">
          <div class="integral-1">
            <div class="">个人积分</div>
            <div class="">0</div>
          </div>
          <div class="integral-1">
            <div class="">积分收入</div>
            <div class="">0</div>
          </div>
          <div class="integral-1">
            <div class="">可提现</div>
            <div class="">0</div>
          </div>
        </div>
      </div>
      <div class="action-list">
        <div class="action-item active">
          充值积分
          <div class="bar"></div>
        </div>
        <div class="action-item" @click="rechargePage">
          兑换流量
          <div class="bar"></div>
        </div>
      </div>
      <div class="package-list">
        <div class="package-item-item" :class="packageID == item.id ? 'active':''" v-for="(item,index) in packageList" :key="index" @click="checkPackage(item)">
          <div class="title">{{item.integral}}积分兑换</div>
          <div class="price">{{item.price}}元</div>
        </div>
      </div>
    <!--<div class="bottom-action-list">
      <div class="action-item">
        <img src="../assets/images/share-icon_03.png" />
        <div>分享推荐</div>
      </div>
      <div class="action-item">
        <img src="../assets/images/agent-icon_03.png" />
        <div>开通代理</div>
      </div>
    </div>-->
    <div class="submit-btn" @click="createOrder">立即订购</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iccid: "",
      packageID: 0,
      packageList: [],
      one: {},
      stockInfo: {},
      loading:false
    }
  },
  methods: {
      rechargePage(){
          this.$router.push({name:'rechargeCheck',query:{iccid:this.iccid,settlementDate:this.stockInfo.settlementDate,short_number:this.stockInfo.short_number}})
      },
      goShop(){
          this.$toast.fail("功能开发中")
      },
    queryPackageList () {
      this.$toast.loading()
      this.fetchData("/package/cardBalancePackage", {iccid: this.iccid}, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.packageList = res.data
        } else {
          this.$toast.fail(res.msg)
          this.packageList = []
        }
      })
    },
    checkPackage (item) {
      this.packageID = item.id
      this.one = item
    },
    createOrder () {
      this.commitorder()
    },
    commitorder () {
      this.$toast.loading()
      if(this.loading) return this.$toast.fail("请勿连续点击或刷新页面")
      if(!this.packageID) return this.$toast.fail("请选择套餐")
        this.$dialog.confirm({
            title:false,
            message:this.iccid+'卡号是否订购'+this.one.price+'元，实际到账'+this.one.integral+'积分，请点击确认进行办理'
        }).then(()=>{
            this.commitorder1()
        })

    },
      commitorder1(){
          this.loading = true;
          this.fetchDataPost("/order/createBalanceOrder", {
              iccid: this.iccid,
              packageID: this.packageID,
          }, (res) => {
              this.$toast.clear()
              this.loading = false
              if (res.code) {
                  WeixinJSBridge.invoke(
                      "getBrandWCPayRequest", res.data,
                      (res) => {
                          if (res.err_msg == "get_brand_wcpay_request:ok") {
                              this.$toast.success("支付成功")
                              this.$router.back()
                          }
                      }
                  )
              } else {
                  if (res.url) {
                      if(res.msg) {
                          this.$dialog.confirm({
                              title: "提示",
                              message: res.msg
                          }).then(() => {
                              // on confirm
                              let query = {}
                              if (res.data) {
                                  query = res.data
                              }
                              sessionStorage.removeItem('token');
                              query.cardno = this.iccid
                              this.$router.push({path: res.url, query: query})
                          }).catch(() => {
                              // on cancel
                          })
                      }else{
                          sessionStorage.removeItem('token');
                          this.$router.push({path: res.url, query: res.data})
                      }
                  } else {
                      if (res.msg.indexOf("appid") !== -1 && res.msg.indexOf("openid") !== -1) {
                          this.$toast.fail("登录失效，请尝试重新进入查询")
                          sessionStorage.clear()
                      } else {
                          this.$dialog.alert({
                              title: '提示',
                              message: res.msg,
                          }).then(() => {

                          });
                      }
                  }
              }
          })
      },
    getStockInfo () {
      this.fetchData("/card/info", {iccid: this.iccid}, (res) => {
        this.stockInfo = res.data
        if (this.stockInfo.amount > 0) {
          this.type = 1
        }
      })
    }
  },
  created: function () {
    let query = this.$route.query
    this.iccid = query.iccid
    this.getStockInfo()
    this.queryPackageList()
  }
}
</script>
<style lang="scss" scoped>
.card-bind{
  width: 6.9rem;
  margin: 0 auto;
  .submit-btn{
    width: 6.9rem;
    border-radius: .3rem;
    background: #0051fe;
    color: #fff;
    font-size: .28rem;
    text-align: center;
    height: .7rem;
    line-height: .7rem;
    margin-top: .4rem;
    position: fixed;
    bottom: .4rem;
    left: .3rem;
  }
  .bottom-action-list{
    display: flex;
    margin: .5rem auto;
    .action-item{
      flex: 1;
      div{
        text-align: center;
        color: #242424;
        font-size: .28rem;
        line-height: .68rem;
      }
      img{
        width: .45rem;
        height: .45rem;
        display: block;
        margin: 0 auto;
      }
    }
  }
  .package-list{
    padding-bottom: 1.4rem;
    .package-item-item{
      padding: 0 .3rem;
      height: .8rem;
      margin: .3rem 0;
      line-height: .8rem;
      display: flex;
      border-radius: .3rem;
      color: #242424;
      border: 1px solid #fff;
      .title{
        flex: 2;
        text-align: left;
        font-size: .3rem;
      }
      .price{
        flex: 1;
        text-align: right;
        font-size: .3rem;
      }
    }
    .active{
      color: #0051fe;
      border: 1px solid #0051fe;
    }
  }
  .action-list{
    margin: .3rem;
    font-size: .3rem;
    color: #656565;
    display: flex;
    .action-item{
      flex: 1;
      text-align: center;
      .bar{
        width: .55rem;
        height: .04rem;
        background: #0051fe;
        margin: .04rem auto;
        border-radius: 4px;
        display: none;
      }
    }
    .active{
      color: #0051fe;
      .bar{
        display: block;
      }
    }
  }
  .top-info{
    width: 6.9rem;
    overflow: hidden;
    border-radius: .3rem;
    .top-1{
        height: 1.05rem;
        background: #f7e0ca;
        width: 6.3rem;
        padding: 0 .3rem;
        position: relative;
      .now-integral{
        color: #6f4935;
        font-size: .3rem;
        line-height: 1rem;
        text-align: left;
      }
      .shop-btn{
        display: inline-block;
        font-size: .24rem;
        color: #6f4935;
        padding: .1rem .2rem;
        border-radius: .16rem;
        background: #fff;
        position: absolute;
        right: .3rem;
        top: .2rem;
      }
    }
    .top-2{
      display: flex;
      background: #eaceb4;
      width: 6.9rem;
      padding:.15rem 0;
      .integral-1{
        flex: 1;
        text-align: center;
        :first-child{
          font-size: .24rem;
          color: #6f4935;
          line-height: .4rem;
        }
        :last-child{
          font-size: .28rem;
          color: #6f4935;
          line-height: .4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cardbalance.vue